import type { ChatConfig, UiTexts } from '../../types/chat'
import styles from './ChatHeader.module.css'

interface Props {
  config: ChatConfig
  texts: UiTexts
  onClose: () => void
}

export default function ChatHeader({ config, texts, onClose }: Props) {
  const initial = (config.botName ?? 'C').slice(0, 1).toUpperCase()

  return (
    <div className={styles.header} data-part="header">
      <div className={styles.avatar} data-part="header-avatar" aria-hidden="true">
        {config.botAvatarUrl ? <img src={config.botAvatarUrl} alt="" /> : initial}
      </div>

      <div className={styles.info}>
        <span className={styles.title} data-part="title">{config.botName}</span>
        <span className={styles.status} data-part="status">{texts.status}</span>
      </div>

      <button type="button" className={styles.closeBtn} data-part="close" onClick={onClose} aria-label={texts.closeChat}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true" focusable="false">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  )
}
